module.exports = __webpack_public_path__ + "static/media/crisis-text-line.549bcab0.png";